module.exports = __webpack_public_path__ + "img/step_four_brand_en.cbb1c3e7.png";